exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tracking[data-v-4d251a91]{padding:.6rem 0}.tracking h3[data-v-4d251a91]{font-size:14px;font-weight:400;white-space:nowrap}.tracking h4[data-v-4d251a91]{font-size:15px;font-weight:600}", ""]);

// exports
